<template>
  <div>
    <SettingGroup title="メッセージ">
      <el-form :model="form.text" :rules="rules">
        <div class="rowLine" v-for="(text, idx) in form.text.messageListText" :key="idx">
          <el-form-item
            class="rowInput"
            :prop="`messageListText.${idx}`"
            :rules="rules.messageListText"
          >
            <el-input
              v-model="form.text.messageListText[idx]"
              :disabled="false"
              placeholder="入力してください"
              @input="validateMessageText(null, form.text.messageListText, () => {})"
            />
          </el-form-item>
          <div class="rowAction">
            <BaseButton
              type="default"
              :transparent="true"
              :disable="false"
              @click="handleDeleteMessage(idx)"
            >
              <img src="@/assets/images/delete.svg" alt="削除" class="deleteIcon" />
            </BaseButton>
          </div>
        </div>

        <div class="rowLine" v-if="form.text.messageListText.length < maxMessages">
          <el-form-item class="rowInput">
            <el-input
              v-model="form.text.messageAddText"
              :disabled="false"
              placeholder="入力してください"
              @input="validateMessageText(null, form.text.messageAddText, () => {})"
            />
          </el-form-item>
          <div class="rowAction">
            <BaseButton
              label="追加"
              class="listBtn"
              type="primary"
              :disable="!form.text.messageAddText"
              @click="handleAddMessage"
            />
          </div>
        </div>
      </el-form>
    </SettingGroup>
  </div>
</template>

<script>
import BaseButton from '@/components/pc/radio/ipradio/atoms/BaseButton.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'
import Encoding from 'encoding-japanese'

export default {
  name: 'SelCallMessageListVue2',
  components: { BaseButton, SettingGroup },
  data () {
    return {
      form: {
        text: {
          messageListText: [],
          messageAddText: null,
          prevMessageText: { list: [], add: null },
        },
      },
      setting: null,
      maxMessages: 10,
      maxMessageLength: 500,
      rules: {
        messageListText: [{ validator: function () {}, trigger: ['change', 'blur'] }],
        messageAddText:  [{ validator: function () {}, trigger: 'change' }],
      },
    }
  },
  computed: {
    ...mapStores(useRadioSettingsStore),
    disableSave () {
      const list = Array.isArray(this.form.text.messageListText) ? this.form.text.messageListText : []
      return list.length === 0 || list.some((text) => !text || String(text).trim() === '')
    },
  },
  created () {
    this.setting = this.radioSettingsStore.getTempSetting()

    this.rules.messageListText[0].validator = this.validateRequired
    this.rules.messageAddText[0].validator = this.validateMessageText

    this.transSetting2Form()

    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })

    this.$watch('disableSave', (val) => {
      this.$emit('disableSave', val)
    }, { immediate: true })
  },
  methods: {
    validateRequired (rule, value, callback) {
      if (!value || String(value).trim() === '') {
        callback(new Error('値を指定してください。'))
        return
      }
      callback()
    },

    validateMessageText(rule, value, callback) {
      if (!value) return callback();

      const allowedKu = (ku) => (ku >= 1 && ku <= 8) || ku === 13 || (ku >= 16 && ku <= 84);
      const encodeSjis = (s) => Encoding.convert(Encoding.stringToCode(s), { to: 'SJIS', from: 'UNICODE', type: 'array' });
      const decodeSjis = (bytes) => Encoding.codeToString(Encoding.convert(bytes, { to: 'UNICODE', from: 'SJIS', type: 'array' }));

      const sjisToKuTen = (b1, b2) => {
        let j1 =
          (b1 >= 0x81 && b1 <= 0x9F) ? (b1 - 0x81) * 2 + 0x21 :
          (b1 >= 0xE0 && b1 <= 0xEF) ? (b1 - 0xC1) * 2 + 0x21 :
          null;
        if (j1 == null) return null;

        let j2;
        if (b2 >= 0x9F && b2 <= 0xFC) { j1 += 1; j2 = b2 - 0x7E; }
        else if (b2 >= 0x40 && b2 <= 0x7E) j2 = b2 - 0x1F;
        else if (b2 >= 0x80 && b2 <= 0x9E) j2 = b2 - 0x20;
        else return null;

        const ku = j1 - 0x20, ten = j2 - 0x20;
        return (ku >= 1 && ku <= 94 && ten >= 1 && ten <= 94) ? { ku, ten } : null;
      };

      const sanitizeOne = (input) => {
        if (!input) return '';

        let out = '';
        let count = 0;

        for (const ch of String(input)) {
          if (count >= this.maxMessageLength) break;

          const cp = ch.codePointAt(0);
          if (cp < 0x20 && ch !== ' ') continue;

          let bytes;
          try { bytes = encodeSjis(ch); } catch { continue; }
          if (!bytes || bytes.length < 1 || bytes.length > 2) continue;

          if (decodeSjis(bytes) !== ch) continue;

          if (bytes.length === 1) {
            const b = bytes[0];
            if (!((b >= 0x20 && b <= 0x7E) || (b >= 0xA1 && b <= 0xDF))) continue;
          } else {
            const kt = sjisToKuTen(bytes[0], bytes[1]);
            if (!kt || !allowedKu(kt.ku)) continue;
          }

          out += ch;
          count += 1;
        }

        return out;
      };

      if (Array.isArray(value)) {
        const prev = Array.isArray(this.form.text.prevMessageText.list) ? this.form.text.prevMessageText.list : [];
        const changedIdx = value.findIndex((text, idx) => text !== prev[idx]);
        if (changedIdx === -1) return callback();

        const sanitized = sanitizeOne(value[changedIdx]);
        this.$set(this.form.text.prevMessageText.list, changedIdx, sanitized);
        this.$set(this.form.text.messageListText, changedIdx, sanitized);
        return callback();
      }

      const sanitized = sanitizeOne(value);
      this.form.text.prevMessageText.add = sanitized;
      this.form.text.messageAddText = sanitized;
      callback();
    },

    transForm2Setting () {
      const data = this.setting && this.setting.SelCall
      if (!data) return
      data.MessageList = [...this.form.text.messageListText]
    },

    transSetting2Form () {
      const data = this.setting && this.setting.SelCall
      if (!data) return
      this.form.text.messageListText = Array.isArray(data.MessageList) ? [...data.MessageList] : []
      if (this.form.text.prevMessageText.list.length === 0) {
        this.form.text.prevMessageText.list = [...this.form.text.messageListText]
      }
    },

    handleDeleteMessage (idx) {
      this.form.text.messageListText.splice(idx, 1)
      this.form.text.prevMessageText.list.splice(idx, 1)
    },

    handleAddMessage () {
      if (this.form.text.messageAddText && this.form.text.messageListText.length < this.maxMessages) {
        this.form.text.messageListText.push(this.form.text.messageAddText)
        this.form.text.prevMessageText.list.push(this.form.text.messageAddText)
        this.form.text.messageAddText = ''
      }
    },
  },
}
</script>

<style scoped>
.rowLine {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.rowInput {
    flex: 1;
}
.rowAction {
    height: 40px;
    display: flex;
    align-items: center;
}

.listBtn {
    margin-left: 8px;
}

.no-border {
    background: transparent;
    border: none !important;
    box-shadow: none !important;
}
.deleteIcon { width: 30px; height: 30px; }
</style>
